import React, { useEffect, useState } from 'react'
import { Alert, Button, Select, Space } from 'antd'
import fetchAPI from '../../../../lib/utils/fetch-api'
import { ReviewDocument } from './result-model'

interface Source {
  taxId: string
  name: string
  confirmed?: string
  options: { Id: string; Name: string; Code: string }[]
}
export default function HistorySupplier({
  path,
  version,
  onSaved,
}: {
  path: string
  version: number
  onSaved: (doc: ReviewDocument) => void
}) {
  const [source, setSource] = useState<Source>()
  const [selected, setSelected] = useState<string>()
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState('')
  useEffect(() => {
    let active = true
    setSource(undefined)
    setSelected(undefined)
    setError('')
    fetchAPI(path + '/history-supplier')
      .then(result => {
        if (active) setSource(result.data)
      })
      .catch(() => undefined)
    return () => {
      active = false
    }
  }, [path, version])
  if (!source?.options?.length || (source.confirmed && !error)) return null
  const apply = async () => {
    setBusy(true)
    setError('')
    try {
      if (!source.confirmed) {
        await fetchAPI(path + '/history-supplier', {
          method: 'POST',
          body: JSON.stringify({ cardId: selected, version }),
        })
        setSource({ ...source, confirmed: selected })
      }
      const result = await fetchAPI(path + '/auto-match-products', {
        method: 'POST',
        timeoutMs: 90000,
        body: JSON.stringify({ version }),
      })
      onSaved(result.data.document)
    } catch (cause) {
      setError(
        cause instanceof Error
          ? cause.message
          : 'Не удалось проверить связь. Откройте подбор заново.',
      )
    } finally {
      setBusy(false)
    }
  }
  return (
    <Alert
      type="info"
      showIcon
      style={{ marginBottom: 12 }}
      message="У поставщика в 1С не указан ИНН"
      description={
        <Space direction="vertical">
          <span>
            Проверьте, какая карточка соответствует {source.name} (ИНН {source.taxId}). ERP запомнит
            ваш выбор для подбора товаров по прошлым поставкам.
          </span>
          <Space wrap>
            <Select
              aria-label="Поставщик в 1С"
              placeholder="Выберите карточку"
              style={{ minWidth: 240 }}
              disabled={busy || !!source.confirmed}
              value={selected}
              onChange={setSelected}
              options={source.options.map(card => ({
                value: card.Id,
                label: `${card.Name} · код ${card.Code}`,
              }))}
            />
            <Button loading={busy} disabled={!selected} onClick={apply}>
              {source.confirmed ? 'Повторить подбор' : 'Запомнить и подобрать товары'}
            </Button>
          </Space>
          {error && <span role="alert">{error}</span>}
        </Space>
      }
    />
  )
}
